
(function(){
  function textOf(el){
    return ((el && (el.innerText || el.textContent || el.getAttribute('aria-label'))) || '').replace(/\s+/g,' ').trim().toLowerCase();
  }
  function isSocial(el){
    return !!(el && el.closest && (
      el.closest('.list-social') ||
      el.closest('.footer__list-social') ||
      el.closest('.social-icons') ||
      el.closest('[class*="social"]')
    ));
  }
  function isShopNowEl(el){
    if (!el || isSocial(el)) return false;
    var txt = textOf(el);
    return (
      txt.indexOf('shop now') !== -1 ||
      el.id === 'sticky-buy-btn' ||
      el.id.indexOf('cro-buy-btn-') === 0 ||
      el.classList.contains('sticky-cta-btn') ||
      el.classList.contains('cro-hero-p__buy-btn') ||
      el.getAttribute('data-shopnow-disabled') === 'true'
    );
  }
  function stop(e){
    if (!e) return false;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    return false;
  }

  ['click','touchend','pointerup'].forEach(function(evt){
    document.addEventListener(evt, function(e){
      var el = e.target && e.target.closest ? e.target.closest('a,button,[role="button"]') : null;
      if (!el || isSocial(el)) return;
      var href = el.getAttribute && (el.getAttribute('href') || '');
      if (isShopNowEl(el) || (href && href.indexOf('/cart/') !== -1 && textOf(el).indexOf('shop') !== -1)) {
        if (el.setAttribute) el.setAttribute('href', '#');
        return stop(e);
      }
    }, true);
  });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || isSocial(form)) return;
    var action = form.getAttribute('action') || '';
    var btn = form.querySelector('button, [type="submit"], .cro-hero-p__buy-btn');
    if (
      form.getAttribute('data-shopnow-disabled') === 'true' ||
      (form.id && form.id.indexOf('cro-product-form-') === 0) ||
      (btn && isShopNowEl(btn)) ||
      (action.indexOf('/cart/add') !== -1 && btn && textOf(btn).indexOf('shop') !== -1)
    ) {
      form.setAttribute('action', '#');
      return stop(e);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('#sticky-buy-btn, .sticky-cta-btn, .cro-hero-p__buy-btn').forEach(function(el){
      el.setAttribute('href', '#');
      el.setAttribute('data-shopnow-disabled', 'true');
      if (el.tagName === 'BUTTON') el.setAttribute('type', 'button');
    });
    document.querySelectorAll('form[id^="cro-product-form-"]').forEach(function(form){
      form.setAttribute('action', '#');
      form.setAttribute('data-shopnow-disabled', 'true');
    });
  });
})();
